import { useState } from "react";
import "../Css/AboutUs.css";
// import HowItWorks from "./HowItWorks.jsx";
import OurExpertise from "./OurExpertise.jsx";
// import OurExperience from "./OurExperience.jsx";
import OurStarStudents from "./OurStarStudents.jsx";
import OurTeachers from "./OurTeachers.jsx";
import WhyChooseUs from "./WhyChooseUs.jsx";
import ChoosingInstitute from "./ChoosingInstitute.jsx";
// import founderImg from "../assets/iitchinmaylogo.png";
import { FaWhatsapp, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import t1 from "../assets/asitlal.jpg";
 
 
const AboutUs = () => {
 
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    userType: "",
    language: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    pin: "",
    courses: [],
  });
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
 
  const handleCheckbox = (course) => {
    setFormData((prev) => ({
      ...prev,
      courses: prev.courses.includes(course)
        ? prev.courses.filter((c) => c !== course)
        : [...prev.courses, course],
    }));
  };
 
  const handleWhatsAppSubmit = (e) => {
    e.preventDefault();
 
    const message = `
📚 *IITians Chinmay Academy Demo Booking Request*
 
👤 Name: ${formData.firstName} ${formData.lastName}
📧 Email: ${formData.email}
📞 Mobile: ${formData.mobile}
👥 You are: ${formData.userType}
🌐 Language: ${formData.language}
 
🏠 Address:
${formData.address1}
${formData.address2}
${formData.city}, ${formData.state} - ${formData.pin}
 
🎯 Courses:
${formData.courses.join(", ")}
`;
 
    const whatsappNumber = "918849189845";
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      message
    )}`;
 
    window.open(url, "_blank");
  };
 
  return (
    <div className="about-page">
 
      {/* HERO */}
      <section className="about-hero">
        <span className="bubble bubble-1"></span>
        <span className="bubble bubble-2"></span>
        <span className="bubble bubble-3"></span>
        <h1>About Us</h1>
      </section>
 
      {/* FOUNDER */}
      <section className="about-content">
        <div className="about-wrapper">
 
          <div className="about-image">
            <img src={t1} alt="Founder - Iitian's Chinmay Academy" />
            <h3>Mr. Asit Godbole</h3>
            <span>FOUNDER OF IITIAN&apos;S CHINMAY ACADEMY</span>
          </div>
 
          <div className="about-text">
            <h4>Few Words From Founder</h4>
            <h2>Quality Education</h2>
 
            <p>
              <strong>IITian's Chinmay Academy</strong> was founded by Asit Godbole, Alumnus from Indian institute of Technology, Kharagpur in 2017 with an aim to make learning a truly fun experience, which is lacking in the current education system. We at Chinmay, constantly work towards giving each student a comfortable, friendly, motivating environment with personalized focus to work towards his/her dream by setting small goals in the right direction, thus vectoring towards success. We make sure that a student is 100% himself, unafraid to ask even the most trivial doubts.
            </p>
 
            <p>
              Our mission is to make quality education accessible and impactful.
            </p>
 
            <div className="about-divider"></div>
          </div>
 
        </div>
      </section>
      <ChoosingInstitute/>
 
<WhyChooseUs />
{/* <HowItWorks /> */}
 
<OurExpertise />
{/* <OurExperience /> */}
<OurTeachers />
<OurStarStudents />
 
      {/* PREMIUM FORM */}
<section className="demo-clean">
  <div className="demo-card">
    <h2>Book Your Free Demo</h2>
    <p className="demo-note">
      Get expert home tuition tailored to your child’s needs
    </p>
 
    <form className="demo-form-clean" onSubmit={handleWhatsAppSubmit}>
 
      {/* ROW 1 */}
      <div className="row">
        <div className="field">
          <label>First Name *</label>
          <input
            name="firstName"
            placeholder="Enter first name"
            onChange={handleChange}
            required
          />
        </div>
 
        <div className="field">
          <label>Last Name *</label>
          <input
            name="lastName"
            placeholder="Enter last name"
            onChange={handleChange}
            required
          />
        </div>
      </div>
 
      {/* ROW 2 */}
      <div className="row">
        <div className="field">
          <label>Email Address *</label>
          <input
            type="email"
            name="email"
            placeholder="example@email.com"
            onChange={handleChange}
            required
          />
        </div>
 
        <div className="field">
          <label>Mobile Number *</label>
          <input
            type="tel"
            name="mobile"
            placeholder="+91 98765 43210"
            onChange={handleChange}
            required
          />
        </div>
      </div>
 
      {/* ROW 3 */}
      <div className="row">
        <div className="field">
          <label>You are *</label>
          <select name="userType" onChange={handleChange} required>
            <option value="">Select</option>
            <option>Student</option>
            <option>Parent</option>
          </select>
        </div>
 
        <div className="field">
          <label>Preferred Language *</label>
          <select name="language" onChange={handleChange} required>
            <option value="">Select</option>
            <option>English</option>
            <option>Hindi</option>
          </select>
        </div>
      </div>
 
      {/* ADDRESS */}
      <div className="field">
        <label>Address *</label>
        <input
          name="address1"
          placeholder="House no, Street, Area"
          onChange={handleChange}
          required
        />
      </div>
 
      <div className="row">
        <div className="field">
          <label>City *</label>
          <input
            name="city"
            placeholder="City"
            onChange={handleChange}
            required
          />
        </div>
 
        <div className="field">
          <label>State *</label>
          <input
            name="state"
            placeholder="State"
            onChange={handleChange}
            required
          />
        </div>
      </div>
 
      <div className="field">
        <label>Pin Code *</label>
        <input
          name="pin"
          placeholder="6-digit pin code"
          onChange={handleChange}
          required
        />
      </div>
 
      {/* COURSES */}
      <div className="course-box">
        <label className="course-label">Course Preference *</label>
        <div className="course-options">
          {["NEET", "IIT-JEE", "11th-12th", "6th-9th", "Pre-Primary"].map(
            (course) => (
              <label key={course} className="course-item">
                <input
                  type="checkbox"
                  onChange={() => handleCheckbox(course)}
                />
                {course}
              </label>
            )
          )}
        </div>
      </div>
 
      {/* ACTION BUTTONS */}
      <div className="demo-actions-clean">
        <button type="submit" className="btn-whatsapp">
          <FaWhatsapp /> Submit on WhatsApp
        </button>
 
        <a href="tel:+918849189845" className="btn-call">
          <FaPhoneAlt /> Call Now
        </a>
      </div>
 
    </form>
  </div>
</section>
 
 
 
 
 
<section className="connect-section">
      <div className="connect-container">
        <h2 className="connect-title">Connect with Us</h2>
 
        <div className="connect-grid">
          {/* Call */}
          <a href="tel:+918849189845" className="connect-card">
            <div className="connect-icon">
              <FaPhoneAlt />
            </div>
            <div className="connect-text">
              <h4>Call us</h4>
              <p>+91 88491 89845</p>
            </div>
          </a>
 
          {/* Email */}
          <a
            href="mailto:asitgodbole@gmail.com"
            className="connect-card"
          >
            <div className="connect-icon">
              <FaEnvelope />
            </div>
            <div className="connect-text">
              <h4>Email us</h4>
              <p>asitgodbole@gmail.com</p>
            </div>
          </a>
 
          {/* Address */}
          <a
            href="https://www.google.com/maps/search/?api=1&query=SF-9%2610+Shivalay+2+Vasna+Rd+Vadodara"
            target="_blank"
            rel="noreferrer"
            className="connect-card"
          >
            <div className="connect-icon">
              <FaMapMarkerAlt />
            </div>
            <div className="connect-text">
              <h4>Visit us</h4>
              <p>
                SF-9 & 10, Shivalay 2, Vasna Rd, above Kheteshwar, opposite HP
                petrol pump, Ashwamegh Nagar, Tandalja, Vadodara – 390007
              </p>
            </div>
          </a>
        </div>
 
      </div>
    </section>
 
    </div>
  );
};
 
export default AboutUs;